export default {
    DAY: 'Day',
    MONTH: 'Month',
    YEAR: 'Year',
    DAY_1_SHORT: 'Mon',
    DAY_2_SHORT: 'Tue',
    DAY_3_SHORT: 'Wed',
    DAY_4_SHORT: 'Thu',
    DAY_5_SHORT: 'Fri',
    DAY_6_SHORT: 'Sat',
    DAY_0_SHORT: 'Sun',
    DAY_1: 'Monday',
    DAY_2: 'Tuesday',
    DAY_3: 'Wednesday',
    DAY_4: 'Thursday',
    DAY_5: 'Friday',
    DAY_6: 'Saturday',
    DAY_0: 'Sunday',
    MONTH_1_SHORT: 'Jan',
    MONTH_2_SHORT: 'Feb',
    MONTH_3_SHORT: 'Mar',
    MONTH_4_SHORT: 'Apr',
    MONTH_5_SHORT: 'May',
    MONTH_6_SHORT: 'Jun',
    MONTH_7_SHORT: 'Jul',
    MONTH_8_SHORT: 'Aug',
    MONTH_9_SHORT: 'Sep',
    MONTH_10_SHORT: 'Oct',
    MONTH_11_SHORT: 'Nov',
    MONTH_12_SHORT: 'Dec',
    MONTH_1: 'January',
    MONTH_2: 'February',
    MONTH_3: 'March',
    MONTH_4: 'April',
    MONTH_5: 'May',
    MONTH_6: 'June',
    MONTH_7: 'July',
    MONTH_8: 'August',
    MONTH_9: 'September',
    MONTH_10: 'October',
    MONTH_11: 'November',
    MONTH_12: 'December',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    PREVIOUS_SHORT: 'Prev',
    NEXT_SHORT: 'Next',
    PREVIOUS_MONTH: 'Previous month',
    NEXT_MONTH: 'Next month',
    FIRST_DAY_OF_WEEK: 0,
    CHOOSE_DATE: 'Choose date',
    CHANGE_DATE: 'Change date',
    CHOSEN_DATE: 'chosen date is',
    DATE_FORMAT: 'dd.mm.yyyy',
    CALENDAR_LABEL: 'Calendar',
};
